import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ActionButton from './buttons/action-button/ActionButton';
import SVGDynamicIcon from './svg-dynamic-icon/SVGDynamicIcon';

export const MEDIA_TYPES_IMAGES = 'image/*';
export const MEDIA_TYPES_VIDEOS = 'video/*';
export const MEDIA_TYPES_IMAGES_OR_VIDEOS = 'image/*,video/*';
export const MEDIA_TYPES_IMAGES_OR_VIDEOS_OR_PDF = 'image/*,video/*,application/pdf';

class ImageUploader extends Component {
  static propTypes = {
    children: PropTypes.any,
    multiple: PropTypes.bool,
    button: PropTypes.shape({
      label: PropTypes.string
    }),
    mediaTypes: PropTypes.oneOf([
      MEDIA_TYPES_IMAGES,
      MEDIA_TYPES_VIDEOS,
      MEDIA_TYPES_IMAGES_OR_VIDEOS,
      MEDIA_TYPES_IMAGES_OR_VIDEOS_OR_PDF
    ]),
    onCancel: PropTypes.func,
    onUpload: PropTypes.func.isRequired,
    forwardedRef: PropTypes.shape({
      current: PropTypes.object
    }),
    hasIcon: PropTypes.bool
  };

  constructor(props) {
    super(props);

    this.fileInput = null;
  }

  componentDidMount() {
    const { onCancel } = this.props;
    if (onCancel) {
      this.fileInput.addEventListener('cancel', onCancel);
    }
  }

  componentWillUnmount() {
    const { onCancel } = this.props;
    if (onCancel) {
      this.fileInput.removeEventListener('cancel', onCancel);
    }
  }

  handleChange = (event) => {
    this.uploadFiles(event.target.files);
  };

  handleClick = (event) => {
    event.stopPropagation();
    this.fileInput.click();
  };

  uploadFiles(files) {
    const { multiple } = this.props;
    if (!files.length) {
      return;
    }
    this.props.onUpload(multiple ? files : files[0]);
  }

  handleInputRef = (ref) => {
    const { forwardedRef } = this.props;

    this.fileInput = ref;

    if (forwardedRef) {
      forwardedRef.current = ref;
    }
  };

  render() {
    const { multiple, button, mediaTypes, hasIcon, children } = this.props;

    return (
      <section
        onClick={!button ? this.handleClick : null}
      >
        <input
          type="file"
          style={{ display: 'none' }}
          multiple={multiple}
          accept={mediaTypes}
          ref={this.handleInputRef}
          onChange={this.handleChange}
        />
        {
          button &&
            <ActionButton
              onClick={this.handleClick}
              {...button}
            >
              {
                hasIcon && (
                  <SVGDynamicIcon
                    name="plus-custom-fg"
                    width="20px"
                    height="10px"
                    customColor="#3a3a3a"
                  />
                )
              }
              {button.label}
            </ActionButton>
        }
        {children}
      </section>
    );
  }
}

export default ImageUploader;
